import { render, staticRenderFns } from "./PillsGroup.vue?vue&type=template&id=5ef37580&scoped=true&lang=pug&"
import script from "./PillsGroup.vue?vue&type=script&lang=js&"
export * from "./PillsGroup.vue?vue&type=script&lang=js&"
import style0 from "./PillsGroup.vue?vue&type=style&index=0&id=5ef37580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef37580",
  null
  
)

export default component.exports